class Favourites
{
    onSuccess(data)
    {
        app.alert.success('', data.message, '');
        app.ajax.reload("#page");
    }

    onError(data)
    {
        app.alert.error('', data.message, '');
    }

    delete(userId)
    {
        app.ajax.delete('/services/user/favourites/delete/', {'user_id': userId}, () => {
            let user = jQuery("#user-" + userId);
            if (user.length) {
                user.slideUp(150);
            } else {
                app.ajax.reload("#page");
            }
        });
    }

    add(userId)
    {
        app.ajax.post('/services/user/favourites/add', {'user_id': userId}, () => {
            app.ajax.reload("#page");
        });
    }
}
